<template>
  <div id="footer">
    <footer>Copyright 2021 Brittany Greenslade</footer>
  </div>
</template>

<script>
export default {
  name: "page-footer",
};
</script>

<style scoped>
#footer {
  display: grid;
  /* height: 10vh; */
  place-items: center;
  width: 100%;
  border-top: 1px solid grey;
  font-size: 14px;
}
</style>
